export enum DialogType {
    None = 'None',
    Add = 'Add',
    Edit = 'Edit',
    New = 'New',
    NewJob = 'New Job',
    NewQuote = 'New Quote',
    NewPrepaymentInvoice = 'New Prepayment Invoice',
    NewPrepaymentBill = 'New Prepayment Bill',
    NewCreditNote = 'New Credit Note',
    Filter = 'Filter',
    Activity = 'Activity',
    Processing = 'Processing',
    Download = 'Download',
    Tab = 'Tab',
    Import = 'Import',
    Allocation = 'Allocation',
    WorkDialog = 'WorkDialog',
    CodeDialog = 'CodeDialog',
    FormDialog = 'FormDialog',
    DayAllocation = 'Day Allocation',
    IntradayAllocation = 'Intraday Allocation',
    SendMail = 'SendMail',
    Message = 'Message',
    Picker = 'Picker',
    Reparent = 'Reparent',
    Details = 'Details',
    View = 'View',
    Email = 'Email',
    Media = 'Media',
    Convert = "Convert",
    Copy = "Copy",
    Payment = 'Payment',
    NewTemplate = 'New Template',
    Template = 'Template',
    ManageTemplate = 'Manage Template',
    Move = "Move",
    MoveWork = "Move Work",
    CopyWork = "Copy Work",
    Task = 'Task',
    Checklist = 'Checklist',
    AddWorkToRun = 'Add Work To Run',
}
